import React, { useContext } from "react";
import clsx from "clsx";
import PageContext from "@PageContext";
import UiContext from "@UiContext";
import ReactLink from "@micado-digital/react-link/ReactLink";
import ReactSVGIcon from "@micado-digital/react-svg-icon/ReactSVGIcon";
import useSystemLinks from "@micado-digital/react-ui/hooks/useSystemLinks";

import styles from "./Newsletter.styles";

const Newsletter = () => {
	const [pageData] = useContext(PageContext);
	const [ui, setUi] = useContext(UiContext);
	const sysLink = useSystemLinks();
	const { lang = "de" } = pageData;

	const css = styles();

	if (!sysLink("newsletter")) {
		return <></>;
	}

	return (
		<div className={clsx(css.newsletter, "mco-view-component-header__newsletter")}>
			<ReactLink
				aria-label={lang === "de" ? "Newsletter abonnieren" : "Subscribe to newsletter"}
				onClick={e => {
					setUi({ ...ui, menuOpen: false });
				}}
				to={sysLink("newsletter")}
			>
				<ReactSVGIcon color="primary" src="/img/icons/newsletter.svg" size={24} />
			</ReactLink>
		</div>
	);
};

export default Newsletter;
